module.exports = __webpack_public_path__ + "media/images/emblems/L_Isle-coat_of_arms-9ce7d22d1038cb88a33954f07cf83a6a.svg";